import { createContext } from 'react';

import type { PromotionContextValue } from './types';

export const PromotionContext = createContext({} as PromotionContextValue);
